"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../../createSvgIcon"));

var _ArrowDown = _interopRequireDefault(require("@rsuite/icon-font/lib/legacy/ArrowDown"));

// Generated by script, don't edit it please.
var ArrowDown = (0, _createSvgIcon["default"])({
  as: _ArrowDown["default"],
  ariaLabel: 'arrow down',
  category: 'legacy',
  displayName: 'ArrowDown'
});
var _default = ArrowDown;
exports["default"] = _default;
module.exports = exports.default;